import React from 'react';
import { Main } from './components';

const PreInvoices = () => <Main />;

export default PreInvoices;
